import { Skeleton } from "@mui/material";
import "./Skeleton.css";
const ExamCardLoader = () => {
  return (
    <div className="exam-skeleton">
      <div className="row">
        <div className="child">
          <Skeleton variant="text" height={30} sx={{ fontSize: "2rem", maxWidth:"35rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "1rem", maxWidth:"25rem"  }} height={20} />
        </div>
        <div className="child">
          <Skeleton variant="circular" width={30} height={30} />
        </div>
      </div>
      <div className="row bottom">
        <div className="child">
          <Skeleton
            variant="text"
            sx={{ fontSize: "1rem" }}
            height={30}
            width={200}
          />
        </div>
        <div className="child">
          <Skeleton variant="rounded" width={100} height={25} />
        </div>
      </div>
    </div>
  );
};

export default ExamCardLoader;
